import BreadcrumbItem from './breadcrumb-item'
export default BreadcrumbItem
